import callAPiBase from './base';

const replyApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/api/replies',
      method: 'GET',
      useToken: true,
      params,
    }),
  get: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/reply?ID=${ID}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/reply',
      method: 'POST',
      useToken: true,
      data,
    }),
  update: ({ ID, data }: { ID: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/reply?ID=${ID}`,
      method: 'PUT',
      useToken: true,
      data,
    }),
  delete: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/reply?ID=${ID}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { replyApi };
export default replyApi;
